import { CheckCircle2Icon } from 'lucide-react';

import useBrainSession from '@/services/BrainSession/useBrainSession.ts';
import { Button } from '@/ui/button-2.tsx';

import BankIDLogo from '../../../../../../assets/images/bankID.svg';
import Circle from '../../../../../../components/Circle/index.ts';
import Section from '../../../../../../components/Section/index.ts';

import GjeldsregisteretLogo from './gjeldsregisteret.webp';

const heroCardClassName =
  'mx-auto mb-16 flex w-full max-w-[900px]! justify-center rounded-lg border border-transparent bg-white px-6 py-6 text-v1-background-200 shadow-[0px_2px_4px_rgba(0,0,0,0.02)] sm:mb-32 sm:px-10 sm:pb-10 sm:pt-10';

const heroInnerClassName = 'flex w-full max-w-[550px] flex-col sm:min-w-[330px]';

const heroButtonClassName = 'mx-auto my-6 max-w-[550px] min-w-[240px] sm:min-w-[330px]';

const BoxWithBullets: React.FC = () => {
  const { toggleChat } = useBrainSession();

  const handleDebtCheckClick = () => {
    toggleChat({
      goal: 'debt_check',
      step: 'refin_present_terms_auto_new',
    });
  };

  return (
    <Section background="primary">
      <Circle
        className="pointer-events-none top-[-180px]! left-[-130px]! hidden lg:block"
        size={380}
        border={80}
        color="lightTransparent"
      />
      <Circle
        className="pointer-events-none top-[160px]! right-[-190px]! hidden lg:block"
        size={380}
        border={80}
        color="lightTransparent"
      />

      <div className={heroCardClassName}>
        <div className={heroInnerClassName}>
          <h1 className="typography-v1-legacy-h2">Sjekk din gjeld i Gjeldsregisteret</h1>
          <p className="mt-6 mb-10 typography-v1-legacy-p1">
            Gjeldsregisteret har oversikt over hvor mye alle nordmenn har i kredittgjeld i form av
            lån eller kredittkort.
          </p>
          <ul className="m-0 flex list-none flex-col p-0">
            {[
              'Logg inn med BankID',
              'Få oversikt over gjelden din, med tall fra Gjeldsregisteret',
              'Få tilbud fra flere banker, for å se hvor mye du kan spare',
            ].map((text) => (
              <li className="mb-6 flex last:mb-0" key={text}>
                <CheckCircle2Icon
                  aria-hidden
                  className="mt-0.5 mr-6 size-6 shrink-0 text-v1-secondary-100"
                  strokeWidth={1.75}
                />
                <p className="m-0 typography-v1-legacy-p1">{text}</p>
              </li>
            ))}
          </ul>
          <Button color="yellow" className={heroButtonClassName} onClick={handleDebtCheckClick}>
            Sjekk min gjeld
          </Button>
          <div className="mx-auto flex max-w-[450px] flex-col items-center min-[500px]:flex-row min-[500px]:justify-between">
            <img
              alt="BankID logo"
              className="m-3 h-auto max-w-[120px] min-[500px]:mx-6 min-[500px]:min-h-[20px] min-[500px]:max-w-[150px]"
              src={BankIDLogo}
            />
            <img
              alt="Gjeldsregisteret logo"
              className="m-3 h-auto max-w-[120px] min-[500px]:mx-6 min-[500px]:min-h-[20px] min-[500px]:max-w-[150px]"
              loading="lazy"
              src={GjeldsregisteretLogo}
            />
          </div>
        </div>
      </div>

      <div className="relative z-2 mx-auto w-full max-w-[900px]! text-white">
        <h2 className="mb-6 typography-v1-legacy-h2 sm:mb-8">Min gjeld</h2>
        <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
          Med tjenesten Min gjeld får du oversikt over den totale gjelden din, samtidig som du får
          sjekket hvor mye du kan spare på lånene dine.
        </h3>
        <p className="m-0 typography-v1-legacy-subtitle2">
          Nordmenn flest er ganske dårlige på å sjekke om de kan spare penger på å bytte avtaler,
          spesielt når det er snakk om temaer som forsikring eller smålån som forbrukslån og
          kredittkort. Kjenner du deg igjen? Det er ingen grunn til å være tro mot en långiver hvis
          du kan få bedre deal et annet sted, for du trenger jo faktisk ikke å betale mer enn du må.
        </p>
      </div>
    </Section>
  );
};

export default BoxWithBullets;
